
<template>
  <div class="flex flex-col w-full h-full items-center justify-center">
    <div class="flex flex-col gap-3 w-full h-full items-center justify-center mt-40 px-5" v-if="loading">
      <span class="text-red-500 mdn-Icon-raios mdn-Icon--md animate-spin"></span>
      <mdn-text class="text-lg font-semibold text-center">{{ message }}</mdn-text>
    </div>
    <div v-show="!loading" class="flex-grow flex flex-col w-full items-center">
      <slot />
    </div>
  </div>
</template>

<script>
import { MdnText } from 'mondrian-vue'

export const TIMELINE_LOADING_STEPS = {
  DADOS_PESSOAIS: 'DADOS_PESSOAIS',
  DADOS_CARTAO: 'DADOS_CARTAO',
  PLANO: 'PLANO',
  PAGAMENTO: 'PAGAMENTO'
}

export default {
  name: 'TimelineLoading',
  components: { MdnText },
  props: {
    loading: Boolean,
    step: String
  },
  computed: {
    message () {
      const data = [
        { step: 'DADOS_PESSOAIS', loadMessage: 'Estamos validando sua linha...' },
        { step: 'DADOS_CARTAO', loadMessage: 'Estamos validando sua forma de pagamento...' },
        { step: 'PLANO', loadMessage: 'Estamos revisando o plano escolhido...' },
        { step: 'PAGAMENTO', loadMessage: 'Estamos processando o seu pagamento...' }
      ]
      return data.find(d => d.step === this.step)?.loadMessage ?? 'Carregando...'
    }
  }
}
</script>
